import { useQuery } from '@tanstack/react-query';
import { partnerApi } from '../../lib/api';

export async function fetchAllTenants(): Promise<{ id: string; name: string }[]> {
  const allTenants: { id: string; name: string }[] = [];
  let cursor: string | null | undefined;
  let hasNextPage = true;

  while (hasNextPage) {
    const response = await partnerApi.getTenants(false, {
      limit: 100,
      fields: ['id', 'name'],
      cursor: cursor ?? undefined,
    });

    const results = response.data?.results ?? [];
    allTenants.push(...results);

    cursor = response.data?.pagination?.cursor;
    hasNextPage = response.data?.pagination?.hasNextPage ?? false;
  }

  return allTenants;
}

export function useTenants() {
  return useQuery({
    queryKey: ['tenants'],
    queryFn: fetchAllTenants,
    staleTime: 5 * 60 * 1000,
  });
}
